var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueApexCharts',{attrs:{"type":"donut","options":_vm.options,"series":_vm.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }